import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

const Action = ({
  primary,
  secondary,
  tertiary,
  children,
  className,
  href,
  to,
  ...props
}) => {
  let baseClass = "action";

  if (primary) {
    baseClass += "__primary";
  } else if (secondary) {
    baseClass += "__secondary";
  } else if (tertiary) {
    baseClass += "__tertiary";
  }

  const componentCls = classnames(baseClass, className);

  let Element, additionalProps;

  if (to || href.startsWith("/")) {
    Element = Link;
    additionalProps = {
      to: href || to,
    };
  } else {
    Element = "a";
    additionalProps = { href };
  }

  return (
    <Element {...props} {...additionalProps} className={componentCls}>
      <span>
        {children}
      </span>
    </Element>
  );
};

Action.propTypes = {
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
  className: PropTypes.string,
  href: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default Action;



// WEBPACK FOOTER //
// ./casper/sass/components/action/action.js